import 'styles/globals.css';
import 'styles/fonts.scss';
import 'styles/overrideStyles.scss';
import 'intersection-observer';
import { UniformTracker } from '@uniformdev/optimize-tracker-react';
import React from 'react';
import Modal from 'react-modal';

import { localTracker } from 'lib/uniform.service';
import { wrapper } from 'app-redux/store/store';
import { UniformConfAppInterface } from 'types/componentTypes';
import { CtmSourceEventType, ExponeaJsSdk } from 'types/objectTypes';

declare global {
  interface Window {
    __sharethis__: any;
    CTMSourceEvent: (event: CtmSourceEventType) => void;
    exponea?: ExponeaJsSdk;
  }
}

Modal.setAppElement('#__next');
const MyApp: React.FC<UniformConfAppInterface> = ({
  tracker,
  pageProps,
  Component,
  scoring,
}) => {
  const trackerInstance = tracker || localTracker;

  return (
    <UniformTracker trackerInstance={trackerInstance} initialIntentScores={scoring}>
      <Component {...pageProps} />
    </UniformTracker>
  );
};

export default wrapper.withRedux(MyApp);
